<template>
  <div class="bg-accent" style="min-height: 90vh">
    <RouterView />
    <!-- <slot></slot> -->
  </div>
</template>
<script setup></script>
<style></style>
